"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//* добавление количества найденых товаров в результате фильтрации в блок визу фильтра 
const changeTextProduct_1 = __importDefault(require("./changeTextProduct"));
//= addTotalFindLampOnPage 
const addTotalFindLampOnPage = (total) => {
    try {
        //console.log('%c addTotalFindLampOnPage >>>', 'color: white; background: green', total);
        const productsElement = document.querySelector('#products');
        if (productsElement && total) {
            const word = (0, changeTextProduct_1.default)(total);
            productsElement.textContent = `Найдено ${total} ${word}`;
        }
        else if (total === 0 && productsElement) {
            productsElement.textContent = `Найдено 0 товаров`;
        }
    }
    catch (error) {
        console.log('Error in fnc addTotalFindLampOnPage >>> ', error);
    }
};
exports.default = addTotalFindLampOnPage;
